import { api } from "roboflex-thalamus-request-handler";
import { absolutizarStorageUrl } from "@/utils/storage-url";
import { digitosDocumentosVisitante, normalizarVisitanteDocumentos } from "@/config/visitante-documentos";

function obterTodos(page){
    return new Promise((resolve, reject) => {
        console.log(page)
        return api.get(`visitante?page=${page}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
}

/**
 * Mesma lógica do mobile (AgendaScreen): com vários resultados da API, se o termo tiver ≥4 dígitos,
 * restringe aos cadastros cujo documento (somente dígitos) contém essa sequência.
 */
function refinarResultadosBuscaVisitante(termo, encontrados) {
    const list = Array.isArray(encontrados) ? encontrados : [];
    if (list.length <= 1) return list;
    const digitos = String(termo || "").replace(/\D/g, "");
    if (digitos.length < 4) return list;
    const porDoc = list.filter((v) => digitosDocumentosVisitante(v).includes(digitos));
    if (porDoc.length >= 1) return porDoc;
    return list;
}

function extrairListaItens(body) {
    if (body == null) return [];
    if (Array.isArray(body)) return body;
    if (typeof body !== "object") return [];
    if (Array.isArray(body.data)) return body.data;
    if (body.data && typeof body.data === "object") return extrairListaItens(body.data);
    return [];
}

function mapVisitanteApi(obj) {
    const docs = normalizarVisitanteDocumentos(obj);
    const cpf = docs.cpf || String(obj.CPF ?? "").trim();
    return {
        id: Number(obj.id || 0),
        nomeCompleto: String(obj.nomeCompleto || obj.nome_completo || ""),
        cpf,
        rg: docs.rg,
        documentoRgCnh: docs.rg,
        /** Alias legado (telas antigas usam `CPF` no template). */
        CPF: cpf,
        email: String(obj.email || ""),
        telefoneWhatsapp: String(obj.celular || obj.telefone_whatsapp || ""),
        /** Alias para telas que exibem `celular`. */
        celular: String(obj.celular || obj.telefone_whatsapp || ""),
        fotoUrl: absolutizarStorageUrl(obj.foto || obj.path_image || obj.pathImage || ""),
        empresa: String(obj.empresa || obj.empresa_origem || obj.empresaOrigem || ""),
    };
}

function buscarPorNome(termo) {
    const q = String(termo || "").trim();
    if (q.length < 2) return Promise.resolve([]);
    return api
        .get("visitante", { params: { search: q, per_page: 50 } })
        .then((response) => {
            const mapped = extrairListaItens(response.data).map(mapVisitanteApi);
            return refinarResultadosBuscaVisitante(q, mapped);
        });
}

function listarTodos(params = {}) {
    const page = Number(params.page || 1);
    const search = String(params.search || "").trim();
    return api
        .get("visitante", { params: { page, search: search || undefined } })
        .then((response) => {
            const body = response?.data ?? {};
            const data = extrairListaItens(body).map((item) => mapVisitanteApi(item));
            return {
                data,
                current_page: Number(body.current_page || page),
                last_page: Number(body.last_page || 1),
                total: Number(body.total || data.length),
            };
        });
}

export default {
    obterTodos,
    buscarPorNome,
    listarTodos,
}